"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getCookie = function getCookie(name) {
  var cookie = document.cookie;
  if (!cookie) return {
    cookieExists: false
  };
  cookie = cookie.split(name + '=');
  var cookieValue, cookieExists;
  //if the split length is 2 that means cookie exists
  if (cookie.length === 2 && cookie[1]) {
    cookieValue = cookie[1].split(';')[0];
    cookieExists = true;
  } else cookieExists = false;
  return {
    cookieExists: cookieExists,
    cookieValue: cookieValue ? cookieValue : null
  };
};
var _default = exports["default"] = getCookie;